import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const NotFound = lazy(() => import('../pages/NotFound'));
const CirugiaVeterinariaAlmeria = lazy(() => import('../pages/cirugia-veterinaria-almeria/page'));
const TraumatologoVeterinarioAlmeria = lazy(() => import('../pages/traumatologo-veterinario-almeria/page'));
const CirugiaOncologicaVeterinariaAlmeria = lazy(() => import('../pages/cirugia-oncologica-veterinaria-almeria/page'));
const ZonasServicio = lazy(() => import('../pages/zonas-servicio/page'));
const CasosClinicos = lazy(() => import('../pages/casos-clinicos/page'));
const CasoHemilaminectomiaNoa = lazy(() => import('../pages/casos-clinicos/hemilaminectomia-cervical-noa-almeria/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/cirugia-veterinaria-almeria',
    element: <CirugiaVeterinariaAlmeria />,
  },
  {
    path: '/traumatologo-veterinario-almeria',
    element: <TraumatologoVeterinarioAlmeria />,
  },
  {
    path: '/cirugia-oncologica-veterinaria-almeria',
    element: <CirugiaOncologicaVeterinariaAlmeria />,
  },
  {
    path: '/zonas-servicio',
    element: <ZonasServicio />,
  },
  {
    path: '/casos-clinicos',
    element: <CasosClinicos />,
  },
  {
    path: '/casos-clinicos/hemilaminectomia-cervical-noa-almeria',
    element: <CasoHemilaminectomiaNoa />,
  },
  // Páginas de Almería
  {
    path: '/traumatologo-veterinario-almeria-capital',
    element: lazy(() => import('../pages/traumatologo-veterinario-almeria-capital/page')),
  },
  {
    path: '/traumatologo-veterinario-roquetas-de-mar',
    element: lazy(() => import('../pages/traumatologo-veterinario-roquetas-de-mar/page')),
  },
  {
    path: '/traumatologo-veterinario-el-ejido',
    element: lazy(() => import('../pages/traumatologo-veterinario-el-ejido/page')),
  },
  {
    path: '/traumatologo-veterinario-nijar',
    element: lazy(() => import('../pages/traumatologo-veterinario-nijar/page')),
  },
  {
    path: '/traumatologo-veterinario-vicar',
    element: lazy(() => import('../pages/traumatologo-veterinario-vicar/page')),
  },
  {
    path: '/traumatologo-veterinario-adra',
    element: lazy(() => import('../pages/traumatologo-veterinario-adra/page')),
  },
  {
    path: '/traumatologo-veterinario-huercal-overa',
    element: lazy(() => import('../pages/traumatologo-veterinario-huercal-overa/page')),
  },
  {
    path: '/traumatologo-veterinario-huercal-almeria',
    element: lazy(() => import('../pages/traumatologo-veterinario-huercal-almeria/page')),
  },
  {
    path: '/traumatologo-veterinario-vera',
    element: lazy(() => import('../pages/traumatologo-veterinario-vera/page')),
  },
  {
    path: '/traumatologo-veterinario-cuevas-almanzora',
    element: lazy(() => import('../pages/traumatologo-veterinario-cuevas-almanzora/page')),
  },
  {
    path: '/traumatologo-veterinario-albox',
    element: lazy(() => import('../pages/traumatologo-veterinario-albox/page')),
  },
  {
    path: '/traumatologo-veterinario-berja',
    element: lazy(() => import('../pages/traumatologo-veterinario-berja/page')),
  },
  // Páginas de Granada
  {
    path: '/traumatologo-veterinario-granada',
    element: lazy(() => import('../pages/traumatologo-veterinario-granada/page')),
  },
  {
    path: '/traumatologo-veterinario-motril',
    element: lazy(() => import('../pages/traumatologo-veterinario-motril/page')),
  },
  {
    path: '/traumatologo-veterinario-almunhecar',
    element: lazy(() => import('../pages/traumatologo-veterinario-almunhecar/page')),
  },
  {
    path: '/traumatologo-veterinario-armilla',
    element: lazy(() => import('../pages/traumatologo-veterinario-armilla/page')),
  },
  {
    path: '/traumatologo-veterinario-maracena',
    element: lazy(() => import('../pages/traumatologo-veterinario-maracena/page')),
  },
  {
    path: '/traumatologo-veterinario-las-gabias',
    element: lazy(() => import('../pages/traumatologo-veterinario-las-gabias/page')),
  },
  {
    path: '/traumatologo-veterinario-loja',
    element: lazy(() => import('../pages/traumatologo-veterinario-loja/page')),
  },
  {
    path: '/traumatologo-veterinario-baza',
    element: lazy(() => import('../pages/traumatologo-veterinario-baza/page')),
  },
  {
    path: '/traumatologo-veterinario-la-zubia',
    element: lazy(() => import('../pages/traumatologo-veterinario-la-zubia/page')),
  },
  {
    path: '/traumatologo-veterinario-atarfe',
    element: lazy(() => import('../pages/traumatologo-veterinario-atarfe/page')),
  },
  {
    path: '/traumatologo-veterinario-albolote',
    element: lazy(() => import('../pages/traumatologo-veterinario-albolote/page')),
  },
  {
    path: '/traumatologo-veterinario-guadix',
    element: lazy(() => import('../pages/traumatologo-veterinario-guadix/page')),
  },
  {
    path: '/traumatologo-veterinario-churriana-vega',
    element: lazy(() => import('../pages/traumatologo-veterinario-churriana-vega/page')),
  },
  {
    path: '/traumatologo-veterinario-santa-fe',
    element: lazy(() => import('../pages/traumatologo-veterinario-santa-fe/page')),
  },
  {
    path: '/traumatologo-veterinario-ogijares',
    element: lazy(() => import('../pages/traumatologo-veterinario-ogijares/page')),
  },
  {
    path: '/traumatologo-veterinario-huetor-vega',
    element: lazy(() => import('../pages/traumatologo-veterinario-huetor-vega/page')),
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
